// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vue-component.process-example .content{border-left:5px solid #ccc;border-bottom:1px solid #ccc;padding:.5em;margin-left:3em;box-sizing:border-box}.vue-component.process-example .content .styled-description{margin-bottom:1em}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
